<template>
  <div>
    <Navigation />
    <v-container>
      <v-card>
        <v-card-title>
          Service Provider Logs
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :loading="isFetchingData" item-key="id" :headers="headers" :items="audit_logs"
          :search="search"></v-data-table>
      </v-card>
    </v-container>

  </div>
</template>

<script>
import { get_provider_schedule_logs } from '../api'
import Navigation from '../components/Navigation'
import store from '../store'
import moment from 'moment'

export default {
  components: {
    Navigation
  },
  data() {
    return {
      isFetchingData: true,
      search: '',
      headers: [
        {
          text: 'Appointment Date',
          value: 'formatted_appointment_date',
        },
        { text: 'Client', value: 'client' },
        { text: 'Email', value: 'email' },
        { text: 'Mobile', value: 'mobile' }
      ],
      audit_logs: []
    }
  },
  mounted() {
    const jwt = store.getters.getJwt
    get_provider_schedule_logs(jwt).then(response => {
      for (var sched of response.data.schedules) {
        this.audit_logs.push({
          formatted_appointment_date: moment(sched.date_appointment_start).format('lll'),
          client: sched.name,
          email: sched.email,
          mobile: sched.mobile_number,
        })
      }

    }).then(() => {

      this.isFetchingData = false
    })

  }

}
</script>

<style></style>